import React from 'react';
import type ServicedeskKnowledgeHubDraftsType from '@atlassian/jira-spa-apps-servicedesk-knowledge-hub-drafts/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskKnowledgeHubDrafts = lazyForPaint<
	typeof ServicedeskKnowledgeHubDraftsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-knowledge-hub-drafts", jiraSpaEntry: "async-servicedesk-knowledge-hub-drafts" */ '@atlassian/jira-spa-apps-servicedesk-knowledge-hub-drafts'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyServicedeskKnowledgeHubDrafts}
		pageId="spa-apps/servicedesk/knowledge-hub/drafts"
		shouldShowSpinner
	/>
);
